import Warning from './Warning';
import Error from './Error';
import Success from './Success';
import Info from './Info';

export default {
  Warning,
  Error,
  Success,
  Info,
};

export const WarningToast = Warning;
export const ErrorToast = Error;
export const SuccessToast = Success;
export const InfoToast = Info;
